import { ArrowRight, FolderClosed, SearchIcon } from "lucide-react";
import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { Flip, ToastContainer, toast } from "react-toastify";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Participants from "../Dashboard/Participants/Participants";
import Select from "react-select";

const PlayerModal = ({ visible, onClose, data }) => {
  const { authenticated, setAuthenticated } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const [searchInput, setSearchInput] = useState("");
  const [searchInputOpen, setSearchInputOpen] = useState(false);
  const [playerOptions, setPlayerOptions] = useState([]);
  const [firstWinner, setfirstWinner] = useState(null);
  const [seccondWinner, setseccondWinnerr] = useState(null);
  const [thirdWinner, setthirdWinner] = useState(null);
  const [fourthWinner, setfourthWinner] = useState(null);
  const [fifthWinner, setfifthWinner] = useState(null);
  const [sixthWinner, setsixthWinner] = useState(null);

  const [seventhWinner, setseventhWinner] = useState(null);
  const [eightWinner, seteightWinner] = useState(null);

  const handleChange = (e) => {
    // console.log(console.log("Event target:", e.target));
    // Get the name and value from the input
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [e.target.name]: e.target.value, // Update the corresponding state key dynamically
    // }));
  };

  useEffect(() => {
    // console.log(data?.type, data?.participants);
    if (data?.participants && Array.isArray(data.participants)) {
      const transformedParticipants = data.participants.map((participant) => ({
        value: participant?.pubgId, // Use a unique identifier
        label: participant?.pubgId + " " + "-" + participant?.pubgName,
        data: participant, // Use the participant's name as the label
      }));

      setPlayerOptions(transformedParticipants);
    }
  }, [data]);
  // { value: 'ocean', label: 'Ocean', color: '#00B8D9', isFixed: true },

  const handleOnClose = (e) => {
    if (e.target.id === "ModalContainer") {
      onClose();
    }
  };
  if (!visible) {
    return null;
  }
  const handleSubmit = async () => {
    const formData = {
      MatchId: data?._id,
      winners: [
        {
          id: firstWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 40) / 100,
          type: "firstWinner",
          team: "",
        },
        {
          id: seccondWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 20) / 100,
          type: "seccondWinner",
          team: "",
        },
        {
          id: thirdWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 10) / 100,
          type: "thirdWinner",
          team: "",
        },
      ],
    };

    // SingleMatchWinners
    await axiosPrivate
      .post(`/listings/SingleMatchWinners/`, formData, {
        withCredentials: true,
      })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        // setLoading(false);
        console.log(err);
      });

    console.log(formData);
  };
  const handleSubmitdDuo = async () => {
    const formData = {
      MatchId: data?._id,
      winners: [
        {
          id: firstWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 20) / 100,
          type: "firstWinner",
          team: "duo1",
        },
        {
          id: seccondWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 20) / 100,
          type: "seccondWinner",
          team: "duo1",
        },
        {
          id: thirdWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 10) / 100,
          type: "thirdWinner",
          team: "duo2",
        },
        {
          id: fourthWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 10) / 100,
          type: "fourthWinner",
          team: "duo2",
        },
        {
          id: fifthWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 5) / 100,
          type: "fifthWinner",
          team: "duo3",
        },
        {
          id: sixthWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 5) / 100,
          type: "sixthWinner",
          team: "duo3",
        },
      ],
    };
    console.log(formData);
    await axiosPrivate
      .post(`/listings/SingleMatchWinners/`, formData, {
        withCredentials: true,
      })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        // setLoading(false);
        console.log(err);
      });
  };

  const handleSubmitdSquad = async () => {
    const formData = {
      MatchId: data?._id,
      winners: [
        {
          id: firstWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 10) / 100,
          type: "firstWinner",
          team: "squad1",
        },
        {
          id: seccondWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 10) / 100,
          type: "seccondWinner",
          team: "squad1",
        },
        {
          id: thirdWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 10) / 100,
          type: "thirdWinner",
          team: "squad1",
        },
        {
          id: fourthWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 10) / 100,
          type: "fourthWinner",
          team: "squad1",
        },
        {
          id: fifthWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 7.5) / 100,
          type: "fifthWinner",
          team: "squad2",
        },
        {
          id: sixthWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 7.5) / 100,
          type: "sixthWinner",
          team: "squad2",
        },
        {
          id: sixthWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 7.5) / 100,
          type: "fifthWinner",
          team: "squad2",
        },
        {
          id: seventhWinner?.data?._id,
          balance: (data?.participants.length * data?.fees * 7.5) / 100,
          type: "sixthWinner",
          team: "squad2",
        },
      ],
    };
    console.log(formData);
    await axiosPrivate
      .post(`/listings/SingleMatchWinners/`, formData, {
        withCredentials: true,
      })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        // setLoading(false);
        console.log(err);
      });
  };

  return (
    <div
      id="ModalContainer"
      onClick={handleOnClose}
      className="fixed inset-0 z-[10001] bg-black bg-opacity-30 backdrop-blur flex justify-center items-center"
    >
      <ToastContainer />
      <div className="bg-black shadow-lg rounded-xl">
        <div className="flex flex-end justify-end">
          <button onClick={onClose} className="mt-1 me-1 mb-1">
            {/* <CloseSVG /> */}
          </button>
        </div>
        {/* {modalData} */}
        <div className="px-5 pb-5 ">
          <div className="p-4">
            <h3 className="text-xl">Update winners - {data?.type} :</h3>
          </div>

          {/* <div className="flex">
            <input
              value={searchInput}
              onChange={(e) => {
                e.preventDefault();
                setSearchInput(e.target.value);
              }}
              type="Number"
              placeholder="Search depositId"
              className="block me-2 appearance-none w-full bg-gray-200 border border-gray-200 text-black py-3 px-4 pr-8 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            />
            <button className="w-[200px] tracking-wide flex justify-between px-3 font-semibold bg-purple-500 text-white-500 w-full  rounded-lg hover:bg-purple-700 hover:text-purple-800 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none">
              Search <SearchIcon />
            </button>
          </div> */}

          {data?.type == "single" ? (
            <>
              <div className="my-2">
                <label>First Winner </label>
                <small className="text-blue-500 ms-2">
                  This player will recieve 40% of{" "}
                  {data?.participants.length * data?.fees} ={" "}
                  {(data?.participants.length * data?.fees * 40) / 100} PKR
                </small>

                <Select
                  className="basic-single text-black"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name="firstWinner"
                  options={playerOptions}
                  id="firstWinnerSingle"
                  defaultValue={firstWinner}
                  onChange={setfirstWinner}
                />
              </div>
              <div className="my-2">
                <label>Seccond Winner </label>
                <small className="text-blue-500 ms-2">
                  This player will recieve 20% of{" "}
                  {data?.participants.length * data?.fees} ={" "}
                  {(data?.participants.length * data?.fees * 20) / 100} PKR
                </small>
                <Select
                  className="basic-single text-black"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name="seccondWinner"
                  options={playerOptions}
                  onChange={setseccondWinnerr}
                  value={seccondWinner}
                />
              </div>
              <div className="my-2">
                <label>Third Winner </label>
                <small className="text-blue-500 ms-2">
                  This player will recieve 10% of{" "}
                  {data?.participants.length * data?.fees} ={" "}
                  {(data?.participants.length * data?.fees * 10) / 100} PKR
                </small>
                <Select
                  className="basic-single text-black"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name="ThirdWinner"
                  options={playerOptions}
                  onChange={setthirdWinner}
                  value={thirdWinner}
                />
              </div>
            </>
          ) : data?.type == "duo" ? (
            <>
              <div className="my-2">
                <label>First Winner - Duo Team 1 </label>
                <small className="text-blue-500 ms-2">
                  This Team will recieve 40% of{" "}
                  {data?.participants.length * data?.fees} ={" "}
                  {(data?.participants.length * data?.fees * 40) / 100} PKR team
                  / 2. {(data?.participants.length * data?.fees * 20) / 100} PKR
                  per Player
                </small>

                <Select
                  className="basic-single text-black"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name="firstWinner"
                  options={playerOptions}
                  id="firstWinnerSingle"
                  defaultValue={firstWinner}
                  onChange={setfirstWinner}
                />
              </div>
              <div className="my-2">
                <label>Seccond Winner - Duo Team 1 </label>
                <small className="text-blue-500 ms-2">
                  This Team will recieve 40% of{" "}
                  {data?.participants.length * data?.fees} ={" "}
                  {(data?.participants.length * data?.fees * 40) / 100} PKR team
                  / 2. {(data?.participants.length * data?.fees * 20) / 100} PKR
                  per Player
                </small>
                <Select
                  className="basic-single text-black"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name="seccondWinner"
                  options={playerOptions}
                  onChange={setseccondWinnerr}
                  value={seccondWinner}
                />
              </div>
              <div className="my-2">
                <label>Third Winner - Duo Team 2 </label>
                <small className="text-blue-500 ms-2">
                  This Team will recieve 20% of{" "}
                  {data?.participants.length * data?.fees} ={" "}
                  {(data?.participants.length * data?.fees * 20) / 100} PKR team
                  / 2. {(data?.participants.length * data?.fees * 10) / 100} PKR
                  per Player
                </small>
                <Select
                  className="basic-single text-black"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name="ThirdWinner"
                  options={playerOptions}
                  onChange={setthirdWinner}
                  value={thirdWinner}
                />
              </div>
              <div className="my-2">
                <label>fourth Winner - Duo Team 2 </label>
                <small className="text-blue-500 ms-2">
                  This Team will recieve 20% of{" "}
                  {data?.participants.length * data?.fees} ={" "}
                  {(data?.participants.length * data?.fees * 20) / 100} PKR team
                  / 2. {(data?.participants.length * data?.fees * 10) / 100} PKR
                  per Player
                </small>
                <Select
                  className="basic-single text-black"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name="FourthWinner"
                  options={playerOptions}
                  onChange={setfourthWinner}
                  value={fourthWinner}
                />
              </div>
              <div className="my-2">
                <label>Fifth Winner - Duo Team 3 </label>
                <small className="text-blue-500 ms-2">
                  This Team will recieve 10% of{" "}
                  {data?.participants.length * data?.fees} ={" "}
                  {(data?.participants.length * data?.fees * 10) / 100} PKR team
                  / 2. {(data?.participants.length * data?.fees * 5) / 100} PKR
                  per Player
                </small>
                <Select
                  className="basic-single text-black"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name="FifthWinner"
                  options={playerOptions}
                  onChange={setfifthWinner}
                  value={fifthWinner}
                />
              </div>
              <div className="my-2">
                <label>sixth Winner - Duo Team 3 </label>
                <small className="text-blue-500 ms-2">
                  This Team will recieve 10% of{" "}
                  {data?.participants.length * data?.fees} ={" "}
                  {(data?.participants.length * data?.fees * 10) / 100} PKR team
                  / 2. {(data?.participants.length * data?.fees * 5) / 100} PKR
                  per Player
                </small>
                <Select
                  className="basic-single text-black"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name="FourthWinner"
                  options={playerOptions}
                  onChange={setsixthWinner}
                  value={sixthWinner}
                />
              </div>
            </>
          ) : (
            <>
              <div className="grid grid-cols-2 grid-row-1 gap-2">
                <div className="my-2">
                  <label>First Winner - squad Team 1 </label>
                  <small className="text-blue-500 ms-2">
                    This Team will recieve 40% of{" "}
                    {data?.participants.length * data?.fees} ={" "}
                    {(data?.participants.length * data?.fees * 40) / 100} PKR
                    team / 2.{" "}
                    {(data?.participants.length * data?.fees * 20) / 100} PKR
                    per Player
                  </small>

                  <Select
                    className="basic-single text-black"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="firstWinner"
                    options={playerOptions}
                    id="firstWinnerSingle"
                    defaultValue={firstWinner}
                    onChange={setfirstWinner}
                  />
                </div>
                <div className="my-2">
                  <label>Seccond Winner - squad Team 1 </label>
                  <small className="text-blue-500 ms-2">
                    This Team will recieve 40% of{" "}
                    {data?.participants.length * data?.fees} ={" "}
                    {(data?.participants.length * data?.fees * 40) / 100} PKR
                    team / 2.{" "}
                    {(data?.participants.length * data?.fees * 20) / 100} PKR
                    per Player
                  </small>
                  <Select
                    className="basic-single text-black"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="seccondWinner"
                    options={playerOptions}
                    onChange={setseccondWinnerr}
                    value={seccondWinner}
                  />
                </div>
                <div className="my-2">
                  <label>Third Winner - squad Team 1 </label>
                  <small className="text-blue-500 ms-2">
                    This Team will recieve 20% of{" "}
                    {data?.participants.length * data?.fees} ={" "}
                    {(data?.participants.length * data?.fees * 20) / 100} PKR
                    team / 2.{" "}
                    {(data?.participants.length * data?.fees * 10) / 100} PKR
                    per Player
                  </small>
                  <Select
                    className="basic-single text-black"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="ThirdWinner"
                    options={playerOptions}
                    onChange={setthirdWinner}
                    value={thirdWinner}
                  />
                </div>
                <div className="my-2">
                  <label>fourth Winner - sqaud Team 1 </label>
                  <small className="text-blue-500 ms-2">
                    This Team will recieve 20% of{" "}
                    {data?.participants.length * data?.fees} ={" "}
                    {(data?.participants.length * data?.fees * 20) / 100} PKR
                    team / 2.{" "}
                    {(data?.participants.length * data?.fees * 10) / 100} PKR
                    per Player
                  </small>
                  <Select
                    className="basic-single text-black"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="FourthWinner"
                    options={playerOptions}
                    onChange={setfourthWinner}
                    value={fourthWinner}
                  />
                </div>
                <div className="my-2">
                  <label>Fifth Winner - sqaud Team 2 </label>
                  <small className="text-blue-500 ms-2">
                    This Team will recieve 10% of{" "}
                    {data?.participants.length * data?.fees} ={" "}
                    {(data?.participants.length * data?.fees * 10) / 100} PKR
                    team / 2.{" "}
                    {(data?.participants.length * data?.fees * 7.5) / 100} PKR
                    per Player
                  </small>
                  <Select
                    className="basic-single text-black"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="FifthWinner"
                    options={playerOptions}
                    onChange={setfifthWinner}
                    value={fifthWinner}
                  />
                </div>
                <div className="my-2">
                  <label>sixth Winner - squad Team 2 </label>
                  <small className="text-blue-500 ms-2">
                    This Team will recieve 10% of{" "}
                    {data?.participants.length * data?.fees} ={" "}
                    {(data?.participants.length * data?.fees * 10) / 100} PKR
                    team / 2.{" "}
                    {(data?.participants.length * data?.fees * 7.5) / 100} PKR
                    per Player
                  </small>
                  <Select
                    className="basic-single text-black"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="FourthWinner"
                    options={playerOptions}
                    onChange={setsixthWinner}
                    value={sixthWinner}
                  />
                </div>
                <div className="my-2">
                  <label>seventh Winner - squad Team 2 </label>
                  <small className="text-blue-500 ms-2">
                    This Team will recieve 10% of{" "}
                    {data?.participants.length * data?.fees} ={" "}
                    {(data?.participants.length * data?.fees * 10) / 100} PKR
                    team / 2.{" "}
                    {(data?.participants.length * data?.fees * 7.5) / 100} PKR
                    per Player
                  </small>
                  <Select
                    className="basic-single text-black"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="FifthWinner"
                    options={playerOptions}
                    onChange={setseventhWinner}
                    value={seventhWinner}
                  />
                </div>
                <div className="my-2">
                  <label>eight Winner - squad Team 2 </label>
                  <small className="text-blue-500 ms-2">
                    This Team will recieve 10% of{" "}
                    {data?.participants.length * data?.fees} ={" "}
                    {(data?.participants.length * data?.fees * 10) / 100} PKR
                    team / 2.{" "}
                    {(data?.participants.length * data?.fees * 7.5) / 100} PKR
                    per Player
                  </small>
                  <Select
                    className="basic-single text-black"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="FourthWinner"
                    options={playerOptions}
                    onChange={seteightWinner}
                    value={eightWinner}
                  />
                </div>
              </div>
            </>
          )}

          <div className="flex justify-between items-center">
            <button
              onClick={() => {
                data?.type == "single"
                  ? handleSubmit()
                  : data?.type == "duo"
                  ? handleSubmitdDuo()
                  : handleSubmitdSquad();
              }}
              className="mt-5 tracking-wide flex justify-between px-3 font-semibold bg-green-500 text-white-500 w-[100px] py-1 rounded-lg hover:bg-green-700 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
            >
              <p> Yes</p> <ArrowRight />
            </button>
            <button
              onClick={() => {
                onClose();
              }}
              className="mt-5 tracking-wide flex justify-between px-3 font-semibold bg-red-500 text-white-500 w-[100px] py-1 rounded-lg hover:bg-red-700 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
            >
              <p> No</p>X
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerModal;
